export const SET_USERS = "SET_USERS";
export const SET_USERS_DATA_LOADING = "SET_USERS_DATA_LOADING";
export const SET_SEARCH_USERS = "SET_SEARCH_USERS";
export const SET_SEARCH_USER_BY_ID = "SET_SEARCH_USER_BY_ID";


